import { getCurrentPosition } from "./methods/getCurrentPosition";
import { isInsideArea } from "./methods/isInsideArea";

export default {
  getCurrentPosition,
  isInsideArea,
};
